import { type PropsWithChildren } from 'react';

import type { DateThresholdConfig } from '../../core/types/thresholds.js';

/**
 * Props for the TimeseriesChart.ThresholdIndicator slot component
 * @public
 */
export type TimeseriesChartThresholdIndicatorProps = DateThresholdConfig;

/**
 * @public
 */
export const ThresholdIndicator = (
  props: PropsWithChildren<TimeseriesChartThresholdIndicatorProps>,
) => null;

ThresholdIndicator['displayName'] = 'TimeseriesChart.ThresholdIndicator';
